// extracted by mini-css-extract-plugin
export default {"wrapper":"fp","form":"gp","required":"hp","label":"ip","small":"jp","noMargin":"kp","success":"lp","circle":"mp","successText":"np","appointment":"op"};